import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import HandshakeIcon from '@mui/icons-material/Handshake';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RestoreIcon from '@mui/icons-material/Restore';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import DeviceUnknownIcon from '@mui/icons-material/DeviceUnknown';
import SettingsIcon from '@mui/icons-material/Settings';

import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
// localItems.js
import vinga from './textures/vinga.jpg'
import gabbro from './textures/gabbro.jpg'
import dymovsky from './textures/dymovsky.jpg'
import mansurovsky from './textures/mansurovsky.jpg'

export const MOCK_OFFICES = [
    { id: "o1", name: "Офис — Москва" },
    { id: "o2", name: "Офис — Тюмень" },
    // { id: "o2", name: "Офис — Апатиты" },
];

export const NAV_BASE = [
    { key: "office", label: "Мой офис", icon: DashboardOutlinedIcon },
    { key: "analytics", label: "Аналитика", icon: QueryStatsOutlinedIcon },
    { key: "categories", label: "Категории", icon: CategoryOutlinedIcon },
    { key: "products", label: "Товары", icon: Inventory2OutlinedIcon },
    { key: "orders", label: "Заказы", icon: ShoppingCartOutlinedIcon },
    { key: "tasks", label: "Задания", icon: AssignmentTurnedInOutlinedIcon },
    { key: "calc3d", label: "Калькулятор 3D", icon: CalculateOutlinedIcon },
    { key: "employees", label: "Сотрудники", icon: GroupOutlinedIcon },
    { key: "warehouse", label: "Склад", icon: WarehouseOutlinedIcon },
    { key: "settings", label: "Настройки", icon: SettingsOutlinedIcon },
    { key: "manualOrder", label: "Ручной заказ", icon: PostAddOutlinedIcon },
];

export const controlPanelActions = [
    { id: 'delete', icon: '🔨', tooltip: 'Удалить', disabled: true },
    { id: 'add', icon: '➕', tooltip: 'Добавить', disabled: false },
    { id: 'moveXPlus', icon: '➡️', tooltip: 'X+', disabled: true },
    { id: 'moveXMinus', icon: '⬅️', tooltip: 'X-', disabled: true },
    { id: 'moveYPlus', icon: '⬆️', tooltip: 'Y+', disabled: true },
    { id: 'moveYMinus', icon: '⬇️', tooltip: 'Y-', disabled: true },
    { id: 'moveZPlus', icon: '🔼', tooltip: 'Z+', disabled: true },
    { id: 'moveZMinus', icon: '🔽', tooltip: 'Z-', disabled: true },
    { id: 'rotatePlus', icon: '🔄', tooltip: 'Поворот+', disabled: true },
    { id: 'rotateMinus', icon: '🔃', tooltip: 'Поворот-', disabled: true },
];

export const karkasModels = [
    { name: 'По умолчанию', path: 'bench_ritual_71.stl', price: '0' }, // Оставляем текущий как дефолтный
    { name: 'скамейка', path: 'bench_ritual_71.stl', price: '0' }, // Оставляем текущий как дефолтный
    { name: 'Лево петли сзади', path: 'gate_left_hinges_back(лево_петли_сзади).stl', price: '5000', partnerPrice: Math.round(5000 * 1.05) },
    { name: 'Лево петли спереди', path: 'gate_left_hinges_front(лево_петли_спереди).stl', price: '5000', partnerPrice: Math.round(5000 * 1.05) },
    { name: 'Лево-право петли сзади', path: 'gate_left_right_hinges_backлево_право_петли_сзади.stl', price: '5500', partnerPrice: Math.round(5500 * 1.05) },
    { name: 'Лево-право петли спереди', path: 'gate_left_right_hinges_frontлево_право_петли_спереди.stl', price: '5500', partnerPrice: Math.round(5500 * 1.05) },
    { name: 'Право-лево петли сзади', path: 'gate_right_left_hinges_backправо_лево_петли_сзади.stl', price: '5500', partnerPrice: Math.round(5500 * 1.05) },
    { name: 'Право-лево петли спереди', path: 'gate_right_left_hinges_frontправо_лево_петли_спереди.stl', price: '5500', partnerPrice: Math.round(5500 * 1.05) },
    { name: 'Право-право петли сзади', path: 'gate_right_right_hinges_backправо_право_петли_сзади.stl', price: '5500', partnerPrice: Math.round(5500 * 1.05) },
    { name: 'Право-право петли спереди', path: 'gate_right_right_hinges_frontправо_право_петли_спереди.stl', price: '5500', partnerPrice: Math.round(5500 * 1.05) },
];
export const fenceModels = [
    { name: 'Нет', path: null, price: '0' },
    { name: 'Ограда 9', path: 'fence_plasma_9.stl', price: '86000', partnerPrice: Math.round(86000 * 1.05) },
    { name: 'Ограда 19', path: 'fence_plasma_19.stl', price: '86000', partnerPrice: Math.round(86000 * 1.05) },
    { name: 'Ограда 18', path: 'fence_plasma_18.stl', price: '86000', partnerPrice: Math.round(86000 * 1.05) },
    { name: 'Ограда 17', path: 'fence_plasma_17.stl', price: '86000', partnerPrice: Math.round(86000 * 1.05) },
    { name: 'Ограда 20', path: 'fence_plasma_20.stl', price: '86000', partnerPrice: Math.round(86000 * 1.05) },
    { name: 'Ограда 39', path: 'ograda39.stl', price: '56000', partnerPrice: Math.round(56000 * 1.05) },
    { name: 'Ограда 40', path: 'ograda40.stl', price: '56000', partnerPrice: Math.round(56000 * 1.05) },
    { name: 'Ограда 41', path: 'ograda41.stl', price: '56000', partnerPrice: Math.round(56000 * 1.05) },
    { name: 'Ограда 42', path: 'ograda42.stl', price: '82000', partnerPrice: Math.round(82000 * 1.05) },
    { name: 'Ограда 43', path: 'ograda43.stl', price: '65000', partnerPrice: Math.round(65000 * 1.05) },
    { name: 'Ограда 44', path: 'ograda44.stl', price: '75000', partnerPrice: Math.round(75000 * 1.05) },
    { name: 'Ограда 45', path: 'ograda45.stl', price: '68000', partnerPrice: Math.round(68000 * 1.05) },
    { name: 'Ограда 46', path: 'ograda46.stl', price: '74000', partnerPrice: Math.round(74000 * 1.05) },
    { name: 'Ограда 47', path: 'ograda47.stl', price: '95000', partnerPrice: Math.round(95000 * 1.05) },
    { name: 'Ограда 48', path: 'ograda48.stl', price: '68500', partnerPrice: Math.round(68500 * 1.05) },
    { name: 'Ограда 49', path: 'ograda49.stl', price: '71200', partnerPrice: Math.round(71200 * 1.05) },
    { name: 'Ограда 50', path: 'ograda50.stl', price: '86300', partnerPrice: Math.round(86300 * 1.05) },
];

export const vaseModels = [
    { name: 'Нет', path: null, price: '0' },
    { name: 'Ваза', path: 'vase.stl', price: '4000', partnerPrice: Math.round(4000 * 1.05) },
    { name: 'Ваза', path: 'vase_1.stl', price: '4600', partnerPrice: Math.round(4000 * 1.05) },
];

export const benchModels = [
    { name: 'Нет', path: null, price: '0' },
    { name: 'Лавочка', path: 'lavochka.stl', price: '9000', partnerPrice: Math.round(9000 * 1.05) },
];

export const tableModels = [
    { name: 'Нет', path: null, price: '0' },
    { name: 'Стол', path: 'stol.stl', price: '7000', partnerPrice: Math.round(7000 * 1.05) },
];

export const floorModels = [
    { name: 'Нет', path: null, price: '0' },
    { name: 'Пол', path: 'floor.stl', price: '12000', partnerPrice: Math.round(12000 * 1.05) },
];

export const concreteModels = [
    { name: 'Нет', path: null, price: '0' },
    { name: 'Бетон', path: 'concrete.stl', price: '10000', partnerPrice: Math.round(10000 * 1.05) },
];
export const concreteLeftModels = [
    { name: 'Нет', path: null, price: '0' },
    { name: 'Бетон', path: 'concrete_left.stl', price: '10000', partnerPrice: Math.round(10000 * 1.05) },
];

export const gravestoneModels = [
    { name: 'Нет', path: null, price: '0' },
    { name: 'Свеча', path: 'candle_gravestone.stl', price: '28000', partnerPrice: Math.round(28000 * 1.05) },
    { name: 'Крест', path: 'cross_gravestone.stl', price: '32000', partnerPrice: Math.round(32000 * 1.05) },
];

export const monumentLeftModels = [
    { name: 'Нет', path: null, price: '0' },
    { name: 'Монумент (левый)', path: 'monument_left.stl', price: '15000', partnerPrice: Math.round(15000 * 1.05) },
    { name: 'Памятник Форма 7', path: 'ПамятникФорма7.obj', price: '20000', partnerPrice: Math.round(20000 * 1.05) },
    { name: 'Спец_1.obj', path: 'Спец_1.obj', price: '28000', partnerPrice: Math.round(28000 * 1.05) },
    { name: 'Спец_3.obj', path: 'Спец_3.obj', price: '28000', partnerPrice: Math.round(28000 * 1.05) },
    { name: 'Спец_4.obj', path: 'Спец_4.obj', price: '28000', partnerPrice: Math.round(28000 * 1.05) },
];

export const materialsGravestone = [
    { value: 'Габро-карельский', label: 'Габро-карельский' },
    { value: 'Винга', label: 'Винга' },
    { value: 'Габбро-диабаз', label: 'Габбро-диабаз' }, // Добавь это значение
];

export const gravestonePolishOptions = [
    { value: '1 сторона', label: 'Полируем только вверх (1 сторона)' },
    { value: '4 стороны', label: '4 стороны полированных' },
];
export const fenceColors = {
    black: '#000000',
    darkGray: '#555555',
    gray: '#808080',
    white: '#FFFFFF',
    brown: '#5C4033',
    gold: '#D4AF37',
    bronze: '#CD7F32',
}

export const fenceColorsUi = {
    'Габбро-диабаз': gabbro,
    'Винга': vinga,
    'Дымовский': dymovsky,
    'Мансуровский': mansurovsky,
    // Металлы (оградки, лавочки)
    'Чёрный (RAL 9005)': '#000000',
    'Антрацит (RAL 7016)': '#2B2B2B',
    'Графит (RAL 7024)': '#3B3F45',
    'Тёмно-серый (RAL 7021)': '#1F2326',
    'Серый (RAL 7040)': '#9DA3A6',
    'Белый (RAL 9016)': '#FFFFFF',
    'Коричневый шоколад (RAL 8017)': '#5C4033',
    'Золото (металлик)': '#D4AF37',
    'Бронза (металлик)': '#CD7F32',
};

export const sceneColors = {
    black: '#000000',
    white: '#FFFFFF',
    blue: '#0000FF',
    gray: '#808080',
};

export const gridColors = {
    gray: '#888888',
    white: '#FFFFFF',
    blue: '#0000FF',
    green: '#00FF00',
};
export const initialDataGraniteTable = [
    // Стела (толщина 50)
    { id: 1, type: "Стела", length: 800, width: 400, thickness: 50, sides: 1, price_1_SidePolished: 4011, price_2_SidePolished: 4576, price_5_SidePolished: 5568 },
    { id: 2, type: "Стела", length: 900, width: 450, thickness: 50, sides: 1, price_1_SidePolished: 5077, price_2_SidePolished: 5791, price_5_SidePolished: 6990 },
    { id: 3, type: "Стела", length: 1000, width: 500, thickness: 50, sides: 1, price_1_SidePolished: 6267, price_2_SidePolished: 7150, price_5_SidePolished: 8574 },
    { id: 4, type: "Стела", length: 1100, width: 550, thickness: 50, sides: 1, price_1_SidePolished: 7584, price_2_SidePolished: 8652, price_5_SidePolished: 10319 },
    { id: 5, type: "Стела", length: 1200, width: 600, thickness: 50, sides: 1, price_1_SidePolished: 9025, price_2_SidePolished: 10296, price_5_SidePolished: 12226 },

    // Стела (толщина 60)
    { id: 6, type: "Стела", length: 800, width: 400, thickness: 60, sides: 1, price_1_SidePolished: 4457, price_2_SidePolished: 5147, price_5_SidePolished: 6863 },
    { id: 7, type: "Стела", length: 900, width: 450, thickness: 60, sides: 1, price_1_SidePolished: 5641, price_2_SidePolished: 6814, price_5_SidePolished: 8819 },
    { id: 8, type: "Стела", length: 1000, width: 500, thickness: 60, sides: 1, price_1_SidePolished: 6964, price_2_SidePolished: 8041, price_5_SidePolished: 10574 },
    { id: 9, type: "Стела", length: 1100, width: 550, thickness: 60, sides: 1, price_1_SidePolished: 8426, price_2_SidePolished: 9730, price_5_SidePolished: 12730 },
    { id: 10, type: "Стела", length: 1200, width: 600, thickness: 60, sides: 1, price_1_SidePolished: 10028, price_2_SidePolished: 11580, price_5_SidePolished: 15085 },

    // Стела (толщина 70)
    { id: 11, type: "Стела", length: 800, width: 400, thickness: 70, sides: 1, price_1_SidePolished: 5032, price_2_SidePolished: 5894, price_5_SidePolished: 7773 },
    { id: 12, type: "Стела", length: 900, width: 450, thickness: 70, sides: 1, price_1_SidePolished: 6369, price_2_SidePolished: 7460, price_5_SidePolished: 9764 },
    { id: 13, type: "Стела", length: 1000, width: 500, thickness: 70, sides: 1, price_1_SidePolished: 7863, price_2_SidePolished: 9209, price_5_SidePolished: 11982 },
    { id: 14, type: "Стела", length: 1100, width: 550, thickness: 70, sides: 1, price_1_SidePolished: 9514, price_2_SidePolished: 11144, price_5_SidePolished: 14427 },
    { id: 15, type: "Стела", length: 1200, width: 600, thickness: 70, sides: 1, price_1_SidePolished: 11323, price_2_SidePolished: 13262, price_5_SidePolished: 17098 },

    // Стела (толщина 80)
    { id: 16, type: "Стела", length: 800, width: 400, thickness: 80, sides: 1, price_1_SidePolished: 5457, price_2_SidePolished: 6398, price_5_SidePolished: 7826 },
    { id: 17, type: "Стела", length: 900, width: 450, thickness: 80, sides: 1, price_1_SidePolished: 6906, price_2_SidePolished: 8098, price_5_SidePolished: 9633 },
    { id: 18, type: "Стела", length: 1000, width: 500, thickness: 80, sides: 1, price_1_SidePolished: 8527, price_2_SidePolished: 9998, price_5_SidePolished: 12068 },
    { id: 19, type: "Стела", length: 1100, width: 550, thickness: 80, sides: 1, price_1_SidePolished: 10317, price_2_SidePolished: 12097, price_5_SidePolished: 14552 },
    { id: 20, type: "Стела", length: 1200, width: 600, thickness: 80, sides: 1, price_1_SidePolished: 12278, price_2_SidePolished: 14397, price_5_SidePolished: 17225 },

    // Стела (толщина 100)
    { id: 21, type: "Стела", length: 1000, width: 500, thickness: 100, sides: 1, price_1_SidePolished: 12278, price_2_SidePolished: 14397, price_5_SidePolished: 17225 },
    { id: 22, type: "Стела", length: 1100, width: 550, thickness: 100, sides: 1, price_1_SidePolished: 13023, price_2_SidePolished: 15158, price_5_SidePolished: 18177 },
    { id: 23, type: "Стела", length: 1200, width: 600, thickness: 100, sides: 1, price_1_SidePolished: 15499, price_2_SidePolished: 18040, price_5_SidePolished: 20363 },

    // Подставка
    { id: 24, type: "Подставка", length: 500, width: 150, thickness: 120, sides: 1, price_1_SidePolished: 1816, price_2_SidePolished: 2035, price_5_SidePolished: 2257 },
    { id: 25, type: "Подставка", length: 600, width: 200, thickness: 150, sides: 1, price_1_SidePolished: 2895, price_2_SidePolished: 3206, price_5_SidePolished: 3645 },
    { id: 26, type: "Подставка", length: 700, width: 200, thickness: 150, sides: 1, price_1_SidePolished: 4193, price_2_SidePolished: 4488, price_5_SidePolished: 5037 },
    { id: 27, type: "Подставка", length: 800, width: 200, thickness: 150, sides: 1, price_1_SidePolished: 5530, price_2_SidePolished: 5923, price_5_SidePolished: 6633 },
    { id: 28, type: "Подставка", length: 800, width: 200, thickness: 200, sides: 1, price_1_SidePolished: 4791, price_2_SidePolished: 5179, price_5_SidePolished: 5750 },

    // Цветник
    { id: 29, type: "Цветник", length: 1000, width: 50, thickness: 70, sides: 1, price_1_SidePolished: 794, price_2_SidePolished: 840 },
    { id: 30, type: "Цветник", length: 1000, width: 50, thickness: 80, sides: 1, price_1_SidePolished: 907, price_2_SidePolished: 949 },
    { id: 31, type: "Цветник", length: 1000, width: 50, thickness: 100, sides: 1, price_1_SidePolished: 1134, price_2_SidePolished: 1176 },

    // Перемычка
    { id: 32, type: "Перемычка", length: 1000, width: 50, thickness: 70, sides: 1, price_1_SidePolished: 794, price_2_SidePolished: 840, price_5_SidePolished: 996 },
    { id: 33, type: "Перемычка", length: 1000, width: 50, thickness: 80, sides: 1, price_1_SidePolished: 907, price_2_SidePolished: 949, price_5_SidePolished: 1132 },
    { id: 34, type: "Перемычка", length: 1000, width: 50, thickness: 100, sides: 1, price_1_SidePolished: 1134, price_2_SidePolished: 1176, price_5_SidePolished: 1416 },
];
export const hoursItems = ["08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18"]
export const minutesItems = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]
export const galleryItem = {
    title: "Галлерея",
    description: "Фотографии размещены случайным образом, так что каждый раз вы можете найти что-то новое и интересное. Мы гарантируем качество нашей продукции и поможем вам сделать правильный выбор. Приятных покупок!",
    namePage: "Все товары"
}

export const characteristicList = (obj, type) => [
    { title: 'Длина', key: 'length', unit: 'мм', condition: obj.categorySlug === 'Skamejki-XZDNVwQ-gl' },
    { title: 'Ширина', key: 'width', unit: 'мм' },
    { title: 'Высота', key: 'height', unit: 'мм' },
    { title: 'Вес', key: 'weight', unit: 'кг' },
    { title: 'Размеры', key: 'size', unit: 'мм' },
    type === "all" && { title: 'Размер упаковки', key: 'size', unit: 'мм' },
    type === "all" && { title: 'Цвет', key: 'color', unit: '' },
].map(item => {
    if (item && item.condition) {
        item.content = `от ${obj[item.key] || 'Уточнить'} ${item.unit}`;
    } else if (item) {
        item.content = `${obj[item.key] || 'Уточнить'} ${item.unit}`;
    }
    return item;
});



export const loggedInMenuItems = (auth, handleClickButton, user) => [
    auth && {
        text: "Панель Управления",
        href: "/adminLayout",
        icon: "",
    },
    auth && {
        text: "Калькулятор оград",
        href: "/fenceCalculator",
        icon: "",
    },
    auth && {
        text: "Мой кабинет",
        href: "/personalInformation",
        icon: "",
    },
    auth && {
        text: "Наши соцсети",
        href: "/contactM",
        icon: "",
    },
    auth && {
        text: user.role === "partner" ? "Старница партнера" : "Стать партнером",
        href: user.role === "partner" ? "/partnerPageSale" : "/partnerPage",
        icon: ""
    },
    auth && {
        text: "Мои заказы",
        href: "/orderPage",
        icon: "",
    },
    !auth && {
        text: "Центр сообщений",
        href: "#",
        icon: ""
    },
    {
        text: "Перейти к скидкам",
        href: "#",
        icon: ""
    },
    {
        text: "Связаться с нами",
        href: "/contacts",
        icon: ""
    },
    {
        text: "Настройки",
        href: "/user/settingPage",
        icon: "",
        handleClickType: auth ? "href" : "button",
        handleClick: () => handleClickButton("Настройки")
    },
];

export const itemsCabinetList = [
    {
        href: "/orderPage",
        text: "Мои заказы",
        icon: <ListAltIcon />
    },
    // {
    //     href: "/chat",
    //     text: "Чаты",
    //     icon: <ListAltIcon />
    // },
    {
        href: "/desiresPage",
        text: "Список желаний",
        icon: <FavoriteBorderIcon />
    },

    {
        href: "/historyProductPage",
        text: "Просмотренные товары",
        icon: <RestoreIcon />
    },
    {
        href: "/applicationCallMePage",
        text: "Заявки на звонок",
        icon: <AppSettingsAltIcon />
    },
    {
        href: "/applicationPage",
        text: "Ваши вопросы",
        icon: <DeviceUnknownIcon />
    },
    // {
    //     href: "/applicationPage!",
    //     text: "Заявки (галлереи)",
    //     icon: <DeviceUnknownIcon />
    // },
    {
        href: "/mailingList",
        text: "Рассылка",
        icon: <NotificationsNoneIcon />
    },
    {
        href: "/partnerPage",
        text: "Партнерсво",
        icon: <HandshakeIcon />
    },
    {
        href: "/user/settingPage",
        text: "Настройки",
        icon: <SettingsIcon />
    },

]


// useEffect(() => {
//     document.addEventListener("scroll", scrollHandler)

//     return function () {
//         document.removeEventListener("scroll", scrollHandler)
//     }
// }, [])

// const scrollHandler = (e) => {
//     if (e.target.documentElement.scrollTop > 250) {
//         setFixedClass(true)
//     }
//     if (e.target.documentElement.scrollTop < 250) {
//         setFixedClass(false)
//     }
// }

// ${fixedClass ? " fixedClass" : ""}

export const officeEmployeesGuide = {
    title: "Как пользоваться сотрудниками офиса",
    subtitle: "Правильная схема: создать приглашение → пользователь принимает → появляется сотрудник → назначаются роль и права.",
    steps: [
        {
            title: "1. Создайте приглашение",
            text: "Введите полный email или username пользователя. Частичный поиск не используется, чтобы не раскрывать данные других пользователей."
        },
        {
            title: "2. Отправьте ссылку",
            text: "Если пользователь уже зарегистрирован, ему придёт уведомление. Если нет — скопируйте ссылку и отправьте её вручную."
        },
        {
            title: "3. Пользователь принимает приглашение",
            text: "Сотрудник появляется в офисе только после принятия приглашения. До этого он не имеет доступа к офису."
        },
        {
            title: "4. Назначьте роль",
            text: "Роль задаёт базовый уровень сотрудника: менеджер, склад, бухгалтер, водитель, установщик или обычный работник."
        },
        {
            title: "5. Настройте права",
            text: "Права уточняют доступ: финансы, заказы, задания, склад, товары, 3D-калькулятор, настройки, сотрудники и уведомления."
        },
        {
            title: "6. Не выдавайте лишний доступ",
            text: "Для обычной работы сотруднику нужно давать только те разделы, которыми он реально пользуется."
        },
        {
            title: "7. Управляйте активными приглашениями",
            text: "Активное приглашение можно отменить. Принятое, отклонённое или истёкшее приглашение повторно использовать нельзя."
        },
        {
            title: "8. Проверяйте список сотрудников",
            text: "После принятия приглашения заявка исчезает из активных, а пользователь появляется в списке сотрудников."
        }
    ],
    rules: [
        {
            title: "Главное правило",
            text: "Глобальная роль пользователя на сайте и роль внутри офиса — разные вещи. Доступ к офису управляется через OfficeMember: роль + permissions."
        },
        {
            title: "Безопасность",
            text: "Нельзя назначить роль выше своей, нельзя редактировать равного или старшего сотрудника, нельзя создать владельца через приглашение."
        }
    ]
};

export const officeEmployeesRoleMatrix = [
    {
        role: "owner",
        label: "Владелец",
        description: "Хозяин офиса. Полный доступ ко всем разделам и управлению.",
        permissions: {
            finance: true,
            orders: true,
            warehouse: true,
            products: true,
            calc3d: true,
            tasks: true,
            settings: true,
            employees: true,
            notifications: true
        }
    },
    {
        role: "admin",
        label: "Администратор офиса",
        description: "Управляющий офисом. Может вести офис, сотрудников, товары, склад и финансы, но не выше владельца.",
        permissions: {
            finance: true,
            orders: true,
            warehouse: true,
            products: true,
            calc3d: true,
            tasks: true,
            settings: true,
            employees: true,
            notifications: true
        }
    },
    {
        role: "manager",
        label: "Менеджер",
        description: "Основная работа с заказами, клиентами, товарами и частью офисных процессов.",
        permissions: {
            finance: true,
            orders: true,
            warehouse: true,
            products: true,
            calc3d: true,
            tasks: true,
            settings: false,
            employees: false,
            notifications: true
        }
    },
    {
        role: "sales",
        label: "Продажи",
        description: "Оформление заказов и работа с товарами без доступа к финансам и настройкам.",
        permissions: {
            finance: false,
            orders: true,
            warehouse: false,
            products: true,
            calc3d: true,
            tasks: true,
            settings: false,
            employees: false,
            notifications: true
        }
    },
    {
        role: "warehouse",
        label: "Склад",
        description: "Работа со складом, материалами, партиями, резервами и остатками.",
        permissions: {
            finance: false,
            orders: true,
            warehouse: true,
            products: false,
            calc3d: false,
            tasks: true,
            settings: false,
            employees: false,
            notifications: true
        }
    },
    {
        role: "accountant",
        label: "Бухгалтер",
        description: "Финансы, баланс, платежи и финансовые операции без управления сотрудниками.",
        permissions: {
            finance: true,
            orders: false,
            warehouse: false,
            products: false,
            calc3d: false,
            tasks: false,
            settings: false,
            employees: false,
            notifications: true
        }
    },
    {
        role: "installer",
        label: "Установщик",
        description: "Доступ к задачам и заказам, связанным с монтажом и выполнением работ.",
        permissions: {
            finance: false,
            orders: true,
            warehouse: false,
            products: false,
            calc3d: false,
            tasks: true,
            settings: false,
            employees: false,
            notifications: true
        }
    },
    {
        role: "driver",
        label: "Водитель",
        description: "Доступ к заказам и логистическим задачам без финансов и настроек.",
        permissions: {
            finance: false,
            orders: true,
            warehouse: false,
            products: false,
            calc3d: false,
            tasks: true,
            settings: false,
            employees: false,
            notifications: true
        }
    },
    {
        role: "worker",
        label: "Работник",
        description: "Минимальный рабочий доступ. Подходит для сотрудников без административных функций.",
        permissions: {
            finance: false,
            orders: true,
            warehouse: false,
            products: false,
            calc3d: false,
            tasks: true,
            settings: false,
            employees: false,
            notifications: true
        }
    }
];

export const permissionLabelsAO = {
    finance: "Финансы",
    orders: "Заказы",
    warehouse: "Склад",
    products: "Товары",
    calc3d: "3D-калькулятор",
    tasks: "Задания",
    settings: "Настройки",
    employees: "Сотрудники",
    notifications: "Уведомления"
};
